import { TIME_CONSTANTS } from '@/utils/constants';

const calculateTimeDifference = (datetime?: string) => {
  if (!datetime) {
    return null;
  }

  const {
    MS_IN_SECOND,
    SECONDS_IN_MINUTE,
    MIN_SECONDS_THRESHOLD,
    SECONDS_IN_DAY,
    SECONDS_IN_HOUR,
  } = TIME_CONSTANTS;

  const futureTime = new Date(datetime).getTime();
  const currentTime = Date.now();
  const diffInSeconds = Math.floor((futureTime - currentTime) / MS_IN_SECOND);

  if (isNaN(diffInSeconds) || diffInSeconds < 0) {
    return null;
  }

  if (diffInSeconds < SECONDS_IN_MINUTE) {
    if (diffInSeconds < MIN_SECONDS_THRESHOLD) {
      return `${MIN_SECONDS_THRESHOLD}s`;
    }

    return `${diffInSeconds}s`;
  }

  const days = Math.floor(diffInSeconds / SECONDS_IN_DAY);
  const hours = Math.floor((diffInSeconds % SECONDS_IN_DAY) / SECONDS_IN_HOUR);
  const minutes = Math.floor((diffInSeconds % SECONDS_IN_HOUR) / SECONDS_IN_MINUTE);

  const timeParts = [];

  if (days > 0) {
    timeParts.push(`${days}d`);
  }

  if (hours > 0) {
    timeParts.push(`${hours}h`);
  }

  if (minutes > 0) {
    timeParts.push(`${minutes}m`);
  }

  return timeParts.join(' ');
};

export default calculateTimeDifference;
